module.exports = __webpack_public_path__ + "static/img/userImg.d46a899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/system/userImg.png
// module id = Y6y6
// module chunks = 16